import { PlatformProviders } from "@ecliptica/game-ui";
import { ACTIVE_LANGS, DEFAULT_LANG, htmlLang, LANG_STORAGE_KEY } from "@ecliptica/i18n";
import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { createSiteI18n } from "./i18n";
import { langFromPath, pathFor } from "./lib/lang";
import "./styles.css";

// Primeira visita a "/" sem escolha guardada, com o navegador noutra língua ATIVA → essa versão.
// (Hoje só o EN está ativo, por isso nunca redireciona.)
function preferredRedirect(): string | null {
  if (window.location.pathname !== "/") return null;
  try {
    if (localStorage.getItem(LANG_STORAGE_KEY)) return null;
  } catch {
    return null;
  }
  const nav = navigator.language.toLowerCase();
  const pick = ACTIVE_LANGS.find((l) => nav.startsWith(l));
  return pick && pick !== DEFAULT_LANG ? pathFor(pick) + window.location.hash : null;
}

const redirect = preferredRedirect();
if (redirect) {
  window.location.replace(redirect);
} else {
  const lang = langFromPath(window.location.pathname);
  const i18n = createSiteI18n(lang);
  document.documentElement.lang = htmlLang(lang);
  const root = document.getElementById("root")!;
  const app = (
    <StrictMode>
      <PlatformProviders i18n={i18n}>
        <BrowserRouter>
          <App lang={lang} />
        </BrowserRouter>
      </PlatformProviders>
    </StrictMode>
  );
  // Páginas pré-renderizadas (build) são "hidratadas"; em desenvolvimento renderiza-se do zero.
  if (root.hasChildNodes()) hydrateRoot(root, app);
  else createRoot(root).render(app);
}
